import moduleDrilling from "@/app/drilling/store/moduleDrilling.js";
import taskSideView from "./components/taskSideView.vue"
import categorySideView from "./components/categorySideView.vue"
import vSelect from 'vue-select'

export default {
  components: {
    taskSideView,
    categorySideView,
    'v-select': vSelect
  },
  data() {
    return {
      selectedMainProjectId: null,
      sidebarTaskActive: false,
      sidebarCategoryActive: false,
      sidebarData: {},
      selectedCategory: { id: null },
      tasks: []
    };
  },
  computed: {
    taskTitle() {
      if (this.selectedCategory === undefined || this.selectedCategory === null) return this.$t('Drilling.Tasks.Title');
      
      return this.$t('Drilling.Tasks.TitleWithSelectedCategory') + (this.$i18n.locale.startsWith('fr') ? this.selectedCategory.nameFr : this.selectedCategory.nameEn); 
    },
    categories() {
      return this.$store.state.drilling.taskCategories;
    }
  },
  watch: {
    selectedCategory() {
      this.refreshTasks();
    }
  },
  mounted() {
    this.$vs.loading();
    const _this = this;
    return this.$store.dispatch("drilling/fetchAllCategories").then(() => {
      if (_this.categories !== null && _this.categories.length > 0)
      {
        _this.selectedCategory = _this.categories[0];
        _this.refreshTasks();
      }
    }).finally(() => {
      _this.$vs.loading.close();
    });
  },
  created() {
    if (!moduleDrilling.isRegistered) {
      this.$store.registerModule("drilling", moduleDrilling);
      moduleDrilling.isRegistered = true;
    }
  },
  methods: {
    refreshCategories() {
      return this.$store.dispatch("drilling/fetchAllCategories").then(() => {
        if (this.selectedCategory === null)
          this.selectedCategory = this.categories[0];
  
        this.refreshTasks();
      }).finally(() => {
        this.$vs.loading.close();
        this.$refs.listCategoryCard.removeRefreshAnimation();
      });
    },
    refreshTasks() {
      if (this.selectedCategory === undefined || this.selectedCategory === null) {
        this.tasks = [];
      }
      else {
        this.tasks = this.categories.find(x => x.id === this.selectedCategory.id).tasks || [];
      }
      this.$refs.listTaskCard.removeRefreshAnimation();
    },
    addCategory() {
      this.sidebarData = { };
      this.toggleCategorySidebar(true);
    },
    editCategory(category) {
      this.sidebarData = structuredClone(category);
      this.toggleCategorySidebar(true);
    },
    addTask() {
      this.sidebarData = { };
      this.toggleTaskSidebar(true);
    },
    editTask(task) {
      this.sidebarData = structuredClone(task);
      this.toggleTaskSidebar(true);
    },
    toggleTaskSidebar(val = false) {
      this.sidebarTaskActive = val;
    },
    toggleCategorySidebar(val = false) {
      this.sidebarCategoryActive = val;
    },
    onTaskUpdated() {
      this.$notifySaveSuccess();
      this.toggleTaskSidebar(false);
    },
    onTaskInserted() {
      this.$notifySaveSuccess();
      this.toggleTaskSidebar(false);
    },
    onCategoryUpdated() {
      this.$notifySaveSuccess();
      this.toggleCategorySidebar(false);
    },
    onCategoryInserted(category) {
      this.selectedCategory = category;
      this.$notifySaveSuccess();
      this.toggleCategorySidebar(false);
    },

    openDeleteTaskConfirm(id, categoryId) {
      this.$deleteConfirmation({
        text: this.$t('Drilling.Tasks.ConfirmDelete'),
        accept: () => this.deleteTask(id, categoryId)
      });
    },

    openDeleteCategoryConfirm(id) {
      this.$deleteConfirmation({
        text: this.$t('Drilling.Categories.ConfirmDelete'),
        accept: () => this.deleteCategory(id)
      });
    },

    deleteCategory(id) {
      return this.$store.dispatch("drilling/removeCategory", id)
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("Drilling.Categories.DeletedConfirmation"));
          this.selectedCategory = null;
          this.$refs.listCategoryCard.refreshcard();
        }).catch((error) => {
          if (error.response.status === 409) {
            this.$refs.listCategoryCard.refreshcard();
          }
        }).finally(() => {
          this.$refs.listCategoryCard.removeRefreshAnimation();
        })
    },

    deleteTask(id, categoryId) {
      return this.$store.dispatch("drilling/removeTask", {id, categoryId})
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("Drilling.Tasks.DeletedConfirmation"));
          this.$refs.listTaskCard.refreshcard();
        }).catch((error) => {
          if (error.response.status === 409) {
            this.$refs.listTaskCard.refreshcard();
          }
        });
    }
  }
};
